<template>
  <div class="image-interlayer">
    <img :src="image" alt="" />
    <div class="more" v-if="showMore" @click="goto(url)">更多</div>
  </div>
</template>
<script>
export default {
  name: "ImageInterlayer",
  data() {
    return {};
  },
  created() {},
  props: {
    image: {
      type: String,
      required: true
    },
    showMore: {
      type: Boolean,
      default: false
    },
    url: {
      type: String
    }
  }
};
</script>

<style lang="less" scoped>
.image-interlayer {
  width: 100%;
  height: 9vw;
  position: relative;
  img {
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }
  .more {
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #666666;
    right: 0;
    height: 100%;
    align-items: center;
    font-size: 14px;
    &::after {
      content: "";
      width: 8px;
      height: 8px;
      border-top: #666666 1px solid;
      border-right: #666666 1px solid;
      transform: rotate(45deg);
    }
  }
}
</style>